import { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { photoUrl } from "@/lib/api";

export const Lightbox = ({ photos, index, onClose, onNav }) => {
  const photo = photos[index];

  const prev = useCallback(() => onNav((index - 1 + photos.length) % photos.length), [index, photos.length, onNav]);
  const next = useCallback(() => onNav((index + 1) % photos.length), [index, photos.length, onNav]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, prev, next]);

  if (!photo) return null;

  return (
    <div
      data-testid="lightbox-overlay"
      className="fixed inset-0 z-[60] bg-ink/97 flex items-center justify-center animate-fade-up"
      onClick={onClose}
    >
      <button
        data-testid="lightbox-close"
        onClick={onClose}
        className="absolute top-5 right-5 text-cream/80 hover:text-gold transition-colors z-10"
        aria-label="Cerrar"
      >
        <X size={32} />
      </button>

      <button
        data-testid="lightbox-prev"
        onClick={(e) => { e.stopPropagation(); prev(); }}
        className="absolute left-3 sm:left-8 text-cream/70 hover:text-gold transition-colors z-10"
        aria-label="Anterior"
      >
        <ChevronLeft size={44} />
      </button>

      <div className="max-w-[90vw] max-h-[85vh] flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
        <img
          data-testid="lightbox-image"
          src={photoUrl(photo)}
          alt={photo.title || "Fotografía"}
          className="max-w-[90vw] max-h-[78vh] object-contain rounded-sm shadow-2xl"
        />
        {(photo.title || photo.description) && (
          <div className="mt-4 text-center">
            {photo.title && <p className="font-serif text-xl text-cream">{photo.title}</p>}
            {photo.description && <p className="text-sm text-cream/60 mt-1">{photo.description}</p>}
          </div>
        )}
        <p className="mt-3 font-mono text-xs text-cream/40">{index + 1} / {photos.length}</p>
      </div>

      <button
        data-testid="lightbox-next"
        onClick={(e) => { e.stopPropagation(); next(); }}
        className="absolute right-3 sm:right-8 text-cream/70 hover:text-gold transition-colors z-10"
        aria-label="Siguiente"
      >
        <ChevronRight size={44} />
      </button>
    </div>
  );
};
